import { resolveCropKeyframeAtTime } from '@/lib/crop/resolveCropKeyframeAtTime';

export type CropCenterKeyframeLike = { time: number; endTime: number; x: number; y: number };

/**
 * Horizontal reframe center (0..1 of the source width) at a source-video
 * time, resolved the same way the editor preview and the export do
 * (`resolveCropKeyframeAtTime`: the covering keyframe, else the previous one
 * held across a gap, else the first). Keyframe `x` is a 0..100 percentage.
 * The camera-move tween between cuts is not reproduced — a capture sits on a
 * single frame, and a cover taken mid-tween uses the covering keyframe.
 */
export function resolveCropCenterXAtTime(
  keyframes: readonly CropCenterKeyframeLike[] | null | undefined,
  sourceTime: number,
): number | null {
  const keyframe = resolveCropKeyframeAtTime(keyframes, sourceTime);
  if (!keyframe) return null;
  return Number.isFinite(keyframe.x) ? Math.min(1, Math.max(0, keyframe.x / 100)) : 0.5;
}
